"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldContainsCompany = exports.classNames = exports.hasRole = exports.isAllowed = void 0;
const isAllowed = (user, permissions) => {
    if (!user) {
        return false;
    }
    return permissions.some(permission => user.permissions.includes(permission));
};
exports.isAllowed = isAllowed;
const hasRole = (user, roles) => {
    if (!user) {
        return false;
    }
    return roles.some(role => user.roles.includes(role));
};
exports.hasRole = hasRole;
const classNames = (...classes) => {
    return classes.filter(Boolean).join(' ');
};
exports.classNames = classNames;
// check if field belongs to user's company, used in authorization for perCompanyField type
function fieldContainsCompany(fieldName, companyName, prefix) {
    if (!fieldName || !companyName)
        return false;
    if (prefix) {
        const expectedStart = `${prefix}_`;
        if (!fieldName.startsWith(expectedStart))
            return false;
        const namePart = fieldName.slice(expectedStart.length);
        return namePart === companyName;
    }
    // No prefix → ignore everything before the first "_"
    const index = fieldName.indexOf("_");
    if (index === -1)
        return false;
    return fieldName.slice(index + 1) === companyName;
}
exports.fieldContainsCompany = fieldContainsCompany;
